
import { IconName } from '../../../shared/interfaces/icon-picker.model';
import { Box, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { PageOuterContainer } from '../../../root-components/layouts/page-outer-container';
import { EmissionsInputCard } from '../../presentation-components/emissons-components/overview/emissions-display/emissions-input-card';
import { PageHeading } from '../../presentation-components/display-elements-components/page-heading';

export const SuperAdminPage = () => {
  const navigate = useNavigate()

  const selectPage = (path: string) => {
    navigate(`/super-admin/${path}`)
  }

  return (
    <PageOuterContainer>
      <PageHeading title='Super Admin' />
      <Grid container spacing={2}>
        <Grid item xl={3} lg={3} md={4} sm={4} xs={6}  >
          <Box sx={{ cursor: 'pointer', height: '100%', }} onClick={() => selectPage('organisations')}>
            <EmissionsInputCard
              icon={IconName.Business}
              title='Organisations'
              description='Log in as another Organisation using Gaia Carbon Accounting'
              backgroundColor='white' />
          </Box>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={4} xs={6}  >
          <Box sx={{ cursor: 'pointer', height: '100%', }} onClick={() => selectPage('usage')}>
            <EmissionsInputCard
              icon={IconName.StackedBarChartOutlined}
              title='Usage'
              description='Per-organisation activity, quiet-client flags and suggestion acceptance'
              backgroundColor='white' />
          </Box>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={4} xs={6}  >
          <Box sx={{ cursor: 'pointer', height: '100%', }} onClick={() => selectPage('release-notes')}>
            <EmissionsInputCard
              icon={IconName.EditNote}
              title='Release Notes'
              description='Create and update release notes'
              backgroundColor='white' />
          </Box>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={4} xs={6}  >
          <Box sx={{ cursor: 'pointer', height: '100%' }} onClick={() => selectPage('conversion-factors')}>
            <EmissionsInputCard
              icon={IconName.Inventory2Outlined}
              title='Conversion Factors'
              description='Create and update emission conversion factors'
              backgroundColor='white'
            />
          </Box>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={4} xs={6}  >
          <Box sx={{ cursor: 'pointer', height: '100%' }} onClick={() => selectPage('supplier-matches')}>
            <EmissionsInputCard
              icon={IconName.Business}
              title='Supplier Matches'
              description='Map common supplier names to the correct Companies House company'
              backgroundColor='white'
            />
          </Box>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={4} xs={6}  >
          <Box sx={{ cursor: 'pointer', height: '100%' }} onClick={() => selectPage('products')}>
            <EmissionsInputCard
              icon={IconName.ShoppingBagOutlined}
              title='Global Products'
              description='Create and update global products'
              backgroundColor='white'
            />
          </Box>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={4} xs={6}  >
          <Box sx={{ cursor: 'pointer', height: '100%' }} onClick={() => selectPage('energy-suppliers')}>
            <EmissionsInputCard
              icon={IconName.ElectricBolt}
              title='Energy Suppliers and Tariffs'
              description='Create and update energy supplier tariffs'
              backgroundColor='white'
            />
          </Box>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={4} xs={6}  >
          <Box sx={{ cursor: 'pointer', height: '100%' }} onClick={() => selectPage('measurement-units')}>
            <EmissionsInputCard
              icon={IconName.Scale}
              title='Measurement Units'
              description='Create and update measurement units'
              backgroundColor='white'
            />
          </Box>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={4} xs={6}  >
          <Box sx={{ cursor: 'pointer', height: '100%' }} onClick={() => selectPage('accreditations')}>
            <EmissionsInputCard
              icon={IconName.VerifiedUser}
              title='Carbon Reduction Target Verifiers'
              description='Create and update verifiers'
              backgroundColor='white'
            />
          </Box>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={4} xs={6}  >
          <Box sx={{ cursor: 'pointer', height: '100%' }} onClick={() => selectPage('transactions')}>
            <EmissionsInputCard
              icon={IconName.AccountBalanceOutlined}
              title='Customer Transactions'
              description='Regenerate customer transactions'
              backgroundColor='white'
            />
          </Box>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={4} xs={6}  >
          <Box sx={{ cursor: 'pointer', height: '100%' }} onClick={() => selectPage('inflation-indices')}>
            <EmissionsInputCard
              icon={IconName.CurrencyPound}
              title='Inflation Indices'
              description='Manage CPI and other inflation indices for spend-based emissions'
              backgroundColor='white'
            />
          </Box>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={4} xs={6}  >
          <Box sx={{ cursor: 'pointer', height: '100%' }} onClick={() => selectPage('emission-categories')}>
            <EmissionsInputCard
              icon={IconName.Inventory2Outlined}
              title='Emission Categories'
              description='Manage friendly category groups and categories for emissions'
              backgroundColor='white'
            />
          </Box>
        </Grid>
        <Grid item xl={3} lg={3} md={4} sm={4} xs={6}  >
          <Box sx={{ cursor: 'pointer', height: '100%' }} onClick={() => selectPage('survey-templates')}>
            <EmissionsInputCard
              icon={IconName.AssignmentOutlined}
              title='Survey Templates'
              description='Build and publish ready-made survey templates for clients to start from'
              backgroundColor='white'
            />
          </Box>
        </Grid>
      </Grid>
    </PageOuterContainer>
  )
}







